<template>
  <div class="container">
    <h1 class="py-4">BANKIT-Choysanユーザサマリ（ユーザ一覧）</h1>
    <div>
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
        >
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import countries from "@/constants/CountriesEnum";
export default {
  name: "UserSummaryList",
  mixins: [utils, master, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  data() {
    return {
      fields: [
        "PID",
        "パートナー名",
        "カード種類ID",
        "カード種類",
/*         "FirstName",
        "LastName",
        "MiddleName",
        "国籍", */
        "契約日",
      ],
      db: firebase.firestore(),
      tableData: [],
      loading: true,
      pid: "",
      partnerName: "",
      card_type_id: "",
      year: "",
      month: "",
      currentPage: 1,
      perPage: 10,
    };
  },
  created: function() {
    this.pid = this.$route.query.pid.toString();
    this.partnerName = this.$route.query.partnerName.toString();
    this.card_type_id = this.$route.query.card_type_id.toString();
    this.year = this.$route.query.year.toString();
    this.month = this.$route.query.month.toString();
    this.loading = true;
    this.loadData();
  },
  methods: {
    async loadData() {
      let choysanCollection = [];
      const queryChoysan = this.db
        .collection("users")
        .where("status", "==", "1")
        .where("pid", "==", this.pid);
      let currentMonthFirstDay = new Date(
        this.year,
        parseInt(this.month) - 1,
        1
      );

      let currentMonthLastDay = new Date(this.year, parseInt(this.month), 0);
      const snapshot = await queryChoysan.get();
      snapshot.forEach((doc) => {
        var data = doc.data();
        if (data.nickname !== "") {
          // empty user who haven't created profile yet
          if (data.phone !== "" && data.phone !== undefined) {
            // valid user with choysanaccount +appUser and with pid
            let userApplyForTimePeriod =
              currentMonthFirstDay <= data.created_at.toDate() &&
              data.created_at.toDate() <= currentMonthLastDay;
            if (userApplyForTimePeriod) {
              // user registered during this month batch
              choysanCollection[data.phone] = data;
            }
          }
        }
      });
      const query = this.db
        .collection("master")
        .where("card_type", "==", this.card_type_id);
      const snapshot2 = await query.get();
      snapshot2.forEach(async (doc) => {
        let masterData = doc.data();
        if (choysanCollection[masterData.mobile] !== undefined) {
          let choysanData = choysanCollection[masterData.mobile];
          let tableItem = {
            PID: choysanData.pid,
            パートナー名: this.partnerName,
            カード種類ID: this.card_type_id,
/*             FirstName: choysanData.first_name_en,
            LastName: choysanData.last_name_en,
            MiddleName: choysanData.middle_name_en,
            国籍: choysanData.country_code, */
            契約日: masterData.contract_date,
          };
          let countryText = this.countries.find(
            (element) => element.code == choysanData.country_code
          );
          if (countryText !== undefined) {
            tableItem.国籍 = countryText.name;
          }
          let cardTypeText = this.card_type_codes[this.card_type_id];
          if (cardTypeText !== undefined) {
            tableItem.カード種類 = cardTypeText;
          }
          this.tableData.push(tableItem);
        }
      });
      this.loading = false;
    },
  },
};
</script>
